<template>
  <div id="new">
    <div>
      <p v-show="adblock" class="has-text-danger" v-html="$t('message.adblock')"></p>
      <br>
    </div>
    <vue-dropzone v-show="!isError && !adblock" v-on:vdropzone-sending="sendingEvent" ref="myVueDropzone" id="dropzone"
                  :options="dropzoneOptions" :useCustomSlot=true :use-custom-dropzone-options=true>
      <div class="dropzone-custom-content">
        <img src="/static/images/upload.svg" width="48" alt="アップローダー">
        <h3 class="title">Drag and drop</h3>
        <div class="subtitle">or click here!</div>
        <div class="subtitle">{{ $t("message.top.subtitle" )}}</div>
      </div>
      <input type="hidden" name="csrf_token" :value="csrfToken">
    </vue-dropzone>
    <br>
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <p class="title">{{ $t("message.top.title.1") }}</p>
          <div class="content">
            <p>{{ $t("message.top.content.1_1") }}<router-link to="/signup">{{ $t("message.top.content.1_2") }}</router-link>{{ $t("message.top.content.1_3") }}</p>
          </div>
        </article>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <p class="title">{{ $t("message.top.title.2") }}</p>
          <div class="content">
            <p>{{ $t("message.top.content.2") }}</p>
          </div>
        </article>
      </div>
    </div>
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <p class="title">{{ $t("message.top.title.3") }}</p>
          <div class="content">
            <p>{{ $t("message.top.content.3") }}</p>
          </div>
        </article>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <p class="title">{{ $t("message.top.title.4") }}</p>
          <div class="content">
            <p>{{ $t("message.top.content.4_1") }}<router-link to="/subscription">{{ $t("message.top.content.4_2") }}</router-link>{{ $t("message.top.content.4_3") }}</p>
          </div>
        </article>
      </div>
    </div>
    <br>
    <modal name="is_uploading" adaptive>
      <div class="uploading has-text-centered">
        <h2>{{ $t("message.top.uploading")}}</h2>
        <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
      </div>
    </modal>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import VueAdBlockDetect from 'vue-adblock-detect'

export default {
  name: 'Top',
  mixins: [VueAdBlockDetect],
  components: {
    vueDropzone: vue2Dropzone
  },
  data () {
    return {
      adblock: false,
      isError: false,
      uploadedFilesName: [],
      stop: false,
      csrfToken: 'test',
      dropzoneOptions: {
        url: process.env.BASE_URL + '/upload',
        maxFilesize: 5000,
        parallelUploads: 5,
        thumbnailWidth: 200,
        addRemoveLinks: false,
        maxFiles: 1000,
        chunking: true,
        chunkSize: 20000000,
        withCredentials: true,
        chunksUploaded: (response, done) => {
          const checkUploaded = (fileName) => {
            let i = 0
            let intr = setInterval(() => {
              this.$axios.get(this.baseURL + '/check_chunk?file_name=' + fileName).then(response => {
                if (response.data === 'ok') {
                  clearInterval(intr)
                  this.$axios.get(this.baseURL + '/finish?csrf_token=' + this.csrfToken, {withCredentials: true})
                  this.$router.push('/uploaded')
                }
              })
              if (++i === 100) clearInterval(intr)
            }, 2000)
          }

          if (typeof response.xhr !== 'undefined') {
            const data = response.xhr.responseText
            const json = JSON.parse(data)
            if (json.is_chunked) {
              const fileName = json.custom_file_name
              let reg = /(.*)(?:\.([^.]+$))/
              this.uploadedFilesName.push({ name: fileName, extension: fileName.match(reg)[2] })
              this.$store.state.uploadedFilesName = this.uploadedFilesName
              this.$modal.show('is_uploading')
              checkUploaded(json.custom_file_name)
            }
          }
        },
        success: (response) => {
          if (typeof response.xhr !== 'undefined') {
            const data = response.xhr.responseText
            const json = JSON.parse(data)
            const fileName = json.custom_file_name
            let reg = /(.*)(?:\.([^.]+$))/
            this.uploadedFilesName.push({name: fileName, extension: fileName.match(reg)[2]})
          }
          // this.uploadedFilesName = アップロードごとに使われる
          // this.$store.state.uploadedFilesName = アップロード後に呼ばれる /uploaded で使われる
        },
        queuecomplete: (response) => {
          // this.stop はエラーがあったときに使われる。
          // エラーに遷移した後に、アップロード画面に飛ばないように
          if (!this.stop) {
            this.$axios.get(this.baseURL + '/finish?csrf_token=' + this.csrfToken, {withCredentials: true})
            this.$store.state.uploadedFilesName = this.uploadedFilesName
            this.$router.push('/uploaded')
          }
        },
        // 今は、API 側で Cookie を見て、ファイルの制限をやってる
        maxfilesexceeded: (response) => {
          this.stop = true
          this.$store.state.uploadedFilesName = this.uploadedFilesName
          this.$router.push(
            {name: 'Uploaded', query: {msg: 'いくつかのファイルはアップロードされませんでした。３ファイルまではアップロードできています。プレミアムになると更に便利になります。'}})
        },
        error: (response) => {
          console.log(response)
          this.stop = true

          // maxfilesexceeded の前にこっちが呼ばれるっぽい
          // response.xhr.responseText undefined 対策
          // upload.chunked は何故か chunk するとエラーがたまに起きる。
          // Todo 本当のエラーが拾えなくなるけどまあええか、、、
          if (typeof response.xhr !== 'undefined') {
            const data = response.xhr.responseText
            const json = JSON.parse(data)
            if (json === 'file_size') {
              this.$router.push({name: 'Error', query: {msg: 'file_size'}})
            } else if (json === 'csrf_check') {
              this.$router.push({name: 'Error', query: {msg: 'csrf_check'}})
            } else if (json === 'no_support') {
              this.$router.push({name: 'Error', query: {msg: 'no_support'}})
            } else if (json === 'reach_3') {
              this.$router.push({name: 'Error', query: {msg: 'reach_3'}})
            } else {
              this.$router.push({name: 'Error', query: {msg: 'unknown'}})
            }
          }
        }
      }
    }
  },
  beforeMount () {
    this.detectAdBlock().then((response) => {
      if (response) {
        this.adblock = true
      }
    })
  },
  created: function () {
    this.$axios.get(this.baseURL + '/csrf_token', {withCredentials: true}).then(response => {
      this.csrfToken = response.data.csrf_token
      this.$store.commit('updateMsg', {msg: this.$i18n.t('message.info.msg'), date: this.$i18n.t('message.info.date'), level: this.$store.state.infoLevel})
    }).catch(() => {
      this.isError = true

      const date = new Date()
      const dd = ('0' + date.getDate()).slice(-2)
      const cdate = date.getFullYear() + '/' + date.getMonth() + 1 + '/' + dd + ' ' + date.getHours() + ':' +
        date.getMinutes() + ':' + date.getSeconds()

      this.$store.commit('updateMsg', {msg: '現在アップロードができません。解消までしばらくお待ち下さい。', date: cdate, level: 'has-text-danger'})
    })
  },
  methods: {
    sendingEvent (file, xhr, formData) {
      formData.append('csrf_token', this.csrfToken)
    }
  }
}
</script>

<style scoped>
  #dropzone {
    background-color: #F8FDFE;
  }
  .dropzone-custom-content {
    text-align: center;
  }
  .dropzone-custom-content > .title {
    color: #B0D2DD;
    font-size: 1.5rem
  }
  .title {
    font-size: 1.2rem;
    color: #59637F;
  }
  .content {
    font-size: 1rem;
    color: #59637F;
  }
  .subtitle {
    color: #B0D2DD;
  }
  .tile.is-child.box {
    background-color: #B0D2DD
  }
  .uploading {
    padding: 5rem
  }
</style>



// WEBPACK FOOTER //
// src/components/Top.vue